"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @see https://api-reference.kevin.eu/public/platform/v0.3#tag/Payment-Initiation-Service
 */
class PaymentService {
    constructor(client) {
        this._client = client;
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/initiatePayment
     */
    initiatePayment(options, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this._client.sendRequest(PaymentService.ROUTES.INIT_PAYMENT, 'post', { bearerToken: token, headers: options.headers, queryParameters: options.query, body: options.body });
            if (!options.lang) {
                return response;
            }
            const confirmLink = new URL(String(response.confirmLink));
            confirmLink.searchParams.append('lang', String(options.lang));
            response.confirmLink = confirmLink.toString();
            return response;
        });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getPayment
     */
    getPayment(options) {
        return this._client.sendRequest(PaymentService.ROUTES.PAYMENT, 'get', {
            bearerToken: options.psuAccessToken,
            pathParameters: { paymentId: options.paymentId },
        });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getPaymentStatus
     */
    getPaymentStatus(options) {
        return this._client.sendRequest(PaymentService.ROUTES.PAYMENT_STATUS, 'get', {
            bearerToken: options.psuAccessToken,
            pathParameters: { paymentId: options.paymentId },
        });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/initiatePaymentRefund
     */
    initiatePaymentRefund(options) {
        return this._client.sendRequest(PaymentService.ROUTES.INITIATE_PAYMENT_REFUND, 'post', {
            headers: options.headers,
            pathParameters: { paymentId: options.paymentId },
            body: { amount: options.amount },
        });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getPaymentRefunds
     */
    getPaymentRefunds(paymentId) {
        return this._client.sendRequest(PaymentService.ROUTES.GET_PAYMENT_REFUNDS, 'get', { pathParameters: { paymentId } });
    }
}
PaymentService.ROUTES = {
    INIT_PAYMENT: '/pis/payment',
    PAYMENT: '/pis/payment/{paymentId}',
    PAYMENT_STATUS: '/pis/payment/{paymentId}/status',
    INITIATE_PAYMENT_REFUND: '/pis/payment/{paymentId}/refunds',
    GET_PAYMENT_REFUNDS: '/pis/payment/{paymentId}/refunds',
};
exports.default = PaymentService;
